import React, { useState } from 'react';
import IntlMessage from '../../components/IntlMessage';
import { Form, Modal, Button, Input } from 'antd';
import orderApi from '../../api/order';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const DropOffModal = (props) => {
  const { open, currentData, onClose, onReload } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const initialValues = {
    drop_off: currentData && currentData.drop_off ? currentData.drop_off : '',
    driver_notes:
      currentData && currentData.driver_notes ? currentData.driver_notes : '',
  };

  const handleSubmit = () => {
    setLoading(true);
    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        orderApi.updateDropOff(currentData.id, data);
        setLoading(false);
        handleCancel();
        onReload();
      })
      .catch(() => setLoading(false))
      .finally(() => setLoading(false));
  };

  const handleCancel = () => {
    onClose();
  };

  const handelFailed = (error) => {
    console.error(error);
  };

  return (
    <Modal
      open={open}
      width="60%"
      title={<IntlMessage id="global.drop_off" />}
      onCancel={handleCancel}
      onOk={handleSubmit}
      footer={
        <>
          <Button onClick={onClose}>
            <IntlMessage id="global.cancel" />
          </Button>
          <Button type="primary" loading={loading} onClick={handleSubmit}>
            <IntlMessage id="global.save" />
          </Button>
        </>
      }
    >
      <Form
        {...layout}
        initialValues={initialValues}
        form={form}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={handelFailed}
      >
        <Form.Item
          name="drop_off"
          label={<IntlMessage id="global.drop_off" />}
          rules={[
            {
              required: false,
              message: 'Please input pickup time!',
            },
          ]}
        >
          <Input placeholder="input drop off" format={'HH:mm'} />
        </Form.Item>
        <Form.Item
          name="driver_notes"
          label={<IntlMessage id="global.driver_notes" />}
          rules={[
            {
              required: false,
              message: 'Please input driver notes!',
            },
          ]}
        >
          <Input.TextArea rows={4} placeholder="Input driver_note" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DropOffModal;
